import React from 'react';
import { Pagination, Skeleton } from '@mui/material';
import DetailsCard from '../DetailsCard';
import StatusPill from '../StatusPill';
import { formatDateTime, getActionDescription, getChangeType, getDetailLines } from './timelineText';
import styles from './SubscriptionTimeline.module.css';

const SkeletonItems = () => [0, 1, 2].map((item) => (
  <li key={item} className={styles.item}>
    <span className={styles.dot} />
    <div className={styles.body}>
      <Skeleton variant="text" width="60%" />
      <Skeleton variant="text" width="40%" />
    </div>
  </li>
));

/** Histórico de mudanças da assinatura como linha do tempo vertical. */
const SubscriptionTimeline = ({ history, pagination, onPageChange, plans, loading }) => {
  const empty = !loading && (!history || history.length === 0);

  return (
    <DetailsCard title="Mudanças na assinatura">
      {empty ? (
        <p className={styles.empty}>Nenhum registro ainda.</p>
      ) : (
        <ol className={styles.timeline}>
          {loading ? <SkeletonItems /> : history.map((item) => {
            const change = getChangeType(item.action, item.details);
            const lines = getDetailLines(item.action, item.details, plans);
            return (
              <li key={item.id} className={styles.item}>
                <span className={styles.dot} />
                <div className={styles.body}>
                  <div className={styles.titleRow}>
                    <span className={styles.title}>{getActionDescription(item.action, item.details)}</span>
                    {change && <StatusPill tone={change.tone}>{change.text}</StatusPill>}
                  </div>
                  {lines.map((line) => (
                    <span key={line} className={styles.detail}>{line}</span>
                  ))}
                  <span className={styles.meta}>
                    {formatDateTime(item.created_at)} · {item.user_name || 'Sistema'}
                  </span>
                </div>
              </li>
            );
          })}
        </ol>
      )}

      {pagination && pagination.total_pages > 1 && (
        <div className={styles.pagination}>
          <Pagination
            count={pagination.total_pages}
            page={pagination.page}
            onChange={(e, page) => onPageChange(page)}
            color="primary"
            size="small"
          />
        </div>
      )}
    </DetailsCard>
  );
};

export default SubscriptionTimeline;
